import React, { Suspense, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { base_url, postHeader } from "../../Helper/request";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { tabData } from "../../Reducer/metaReducer";
import ReCAPTCHA from "react-google-recaptcha";
import { LiveChatWidget, EventHandlerPayload } from "@livechat/widget-react";

const Footer = () => {
  function handleNewEvent() {
    console.log("LiveChatWidget");
  }
  const metaText = useSelector(
    (state) => state?.persistedReducer?.meta?.meta?.content
  );
  const dispatch = useDispatch();
  const storeLocation = useSelector(
    (state) => state.persistedReducer.home.store_locations
  );
  const [visible, setVisible] = useState(false);
  const history = useNavigate();
  const [newslettername, setNewslettername] = useState("");
  const [newsletteremail, setNewsletteremail] = useState("");
  const [loader, setLoader] = useState(false);
  const [captchaStatus, setcaptchaStatus] = useState(true);
  const [isLiveChatLoaded, setIsLiveChatLoaded] = useState(false);
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 500) {
      setVisible(true);
    } else if (scrolled <= 500) {
      setVisible(false);
    }
  };
  const tabHandle = (val) => {
    dispatch(tabData(val));
    window.scrollTo({
      top: 400,
      behavior: "smooth",
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  window.addEventListener("scroll", toggleVisible);

  const hndlnewsletter = (e) => {
    e.preventDefault();
    const data = {
      name: newslettername,
      email: newsletteremail,
    };
    if (window?.klaviyo) {
      window.klaviyo.push([
        "identify",
        {
          email: newsletteremail,
          name: newslettername,
          news_Latter: "News Latter",
        },
      ]);
    }
    setLoader(true);
    // window.woopra.track("newsletter", {
    //   email: newsletteremail,
    // });
    axios
      .post(base_url + "/common/subscribe_newsletter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setLoader(false);
          setNewslettername("");
          setNewsletteremail("");
          return toast(res.data.message, "", "success");
        } else {
          setLoader(false);
          return toast(res.data.message, "", "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };
  const capthcaHandle = (res) => {
    if (res) {
      setcaptchaStatus(false);
    }
  };

  // Load LiveChat AFTER Page Load
  useEffect(() => {
    const loadLiveChat = () => {
      setIsLiveChatLoaded(true);
    };

    setTimeout(loadLiveChat, 2000); // Load LiveChat 5 seconds after page load
  }, []);

  return (
    <>
      {/* {
        metaText && metaText !== null && <div className='metaSection mb-4 mt-3'>
          <Container>
            <div dangerouslySetInnerHTML={{ __html: metaText }} />
          </Container>
        </div>
      } */}
      <footer className="footer">
        {/* <Container className='d-none'>
                    <Row>
                        <Col md={3} lg={3}>
                            <div className='footer_box'>
                                <h1 className='text-white'>CUSTOMER SUPPORT</h1>
                                <ul className='footer_link'>
                                    <li><Link to='/contact-us'>Contact Us</Link></li>
                                    <li><Link to='#'>Returns & Exchanges</Link></li>
                                    <li><Link to='#'>Shipping</Link></li>
                                    <li><Link to='#'>FAQ</Link></li>
                                </ul>
                            </div>
                        </Col>
                        <Col md={3} lg={3}>
                            <div className='footer_box'>
                                <h1 className='text-white'>CONNECT WITH US</h1>
                                <ul className='footer_link'>
                                    <li><Link to='https://www.instagram.com/weddingdaydiamonds/' target='_blank'>Instagram</Link></li>
                                    <li><Link to='https://www.facebook.com/WeddingDayDiamondsMN/' target='_blank'>Facebook</Link></li>
                                    <li><Link to='https://www.tiktok.com/@weddingdaydiamonds' target='_blank'>TikTok</Link></li>
                                    <li><Link to='https://br.pinterest.com/weddingdaydiamonds/' target='_blank'>Pinterest</Link></li>
                                    <li><Link to='https://www.youtube.com/c/weddingdaydiamonds' target='_blank'>YouTube</Link></li>
                                </ul>
                            </div>
                        </Col>
                        <Col md={3} lg={3}>
                            <div className='footer_box'>
                                <h1 className='text-white'>FIND A SHOWROOM</h1>
                                <ul className='footer_link'>
                                    <li><Link to='#'>Minnesota</Link></li>
                                    {storeLocation?.map(stores=>
                                       <li className='ps-3'><Link to='#'>{stores.location}</Link></li>
                                    )}
                                </ul>
                                <ul className='footer_link mt-2'>
                                    <li><Link to='#'>Virtual Appointment</Link></li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container> */}

        <Container fluid>
          <Row>
            <Col md={12} lg={9} className="p-0">
              <div className="footer_row">
                <div className="footer_box">
                  <h2 className="text-white footerTitle">SUPPORT</h2>
                  <ul className="footer_link">
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/customer-service">Customer Service</Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/customer-service/our-warranty">
                          Warranty
                        </Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/repairs">Repairs</Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/customer-service/returns-exchanges">
                          Returns & Exchanges
                        </Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/customer-service/shipping">Shipping</Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/financing">Financing</Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/customer-service/custom-design-faq">
                          FAQ
                        </Link>
                      </h3>
                    </li>
                  </ul>
                </div>
                <div className="footer_box">
                  <h2 className="text-white footerTitle">LEARN</h2>
                  <ul className="footer_link">
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/ring-promise">Perfect Ring Promise</Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/education">Education</Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/our-difference">Our Difference</Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/blog">Blog</Link></h3>
                      {/* <h3 className="m-0 d-contents">
                        <a rel="noreferrer"
                          target="_blank"
                          href="https://www.facet.weddingdaydiamonds.com/"
                        >
                          Blog
                        </a>
                      </h3> */}
                    </li>
                  </ul>
                </div>
                <div className="footer_box">
                  <h2 className="text-white footerTitle">Connect</h2>
                  <ul className="footer_link">
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/contact-us">Contact Us</Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link
                          to="https://www.instagram.com/weddingdaydiamonds/"
                          target="_blank"
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 448 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
                          </svg>
                          Instagram
                        </Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link
                          to="https://www.facebook.com/WeddingDayDiamondsMN/"
                          target="_blank"
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 24 24"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M9.94474914,22 L9.94474914,13.1657526 L7,13.1657526 L7,9.48481614 L9.94474914,9.48481614 L9.94474914,6.54006699 C9.94474914,3.49740494 11.8713513,2 14.5856738,2 C15.8857805,2 17.0033128,2.09717672 17.3287076,2.13987558 L17.3287076,5.32020466 L15.4462767,5.32094085 C13.9702212,5.32094085 13.6256856,6.02252733 13.6256856,7.05171716 L13.6256856,9.48481614 L17.306622,9.48481614 L16.5704347,13.1657526 L13.6256856,13.1657526 L13.6845806,22"
                            ></path>
                          </svg>
                          Facebook
                        </Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link
                          to="https://br.pinterest.com/weddingdaydiamonds/"
                          target="_blank"
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 384 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"></path>
                          </svg>
                          Pinterest
                        </Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link
                          to="https://www.tiktok.com/@weddingdaydiamonds"
                          target="_blank"
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 448 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"></path>
                          </svg>
                          TikTok
                        </Link>
                      </h3>
                    </li>
                    {/* <li><Link to='https://www.youtube.com/c/weddingdaydiamonds' target='_blank'>YouTube</Link></li> */}
                  </ul>
                </div>
                <div className="footer_box">
                  <h2 className="text-white footerTitle">Find A Showroom</h2>
                  <ul className="footer_link">
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/showroom">Locations</Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/book-an-appointment">
                          Book an Appointment
                        </Link>
                      </h3>
                    </li>
                    <li>
                      <h3 className="m-0 d-contents">
                        <Link to="/virtual-appointment">
                          Virtual Appointment
                        </Link>
                      </h3>
                    </li>
                  </ul>
                </div>
                <div className="footer_box">
                  <h2 className="text-white footerTitle">Events</h2>
                  <ul className="footer_link">
                    {/* <li>
                      <h3 className='m-0 d-contents'><Link to="/fall-band-event">Fall Band Event</Link></h3>
                    </li>  */}
                    <li>
                      <Link to="/spring-band-event">Band Event</Link>
                    </li>
                    {/* <li><Link to='/stay-tuned'>Holiday</Link></li> */}
                    {/* <li>
                      <h3 className='m-0 d-contents'><Link to="/fall-band-event">Wedding Band Event</Link></h3>
                    </li> */}
                    {/* <li><h3 className='m-0 d-contents'><Link to='/stay-tuned'>Community</Link></h3></li> */}
                  </ul>
                  <h2 className="footer_sublink footerTitle m-0 d-contents">
                    <Link to="/sell-gold-silver-jewelry">Sell Gold & Silver</Link>
                  </h2>
                  <h2 className="footer_sublink footerTitle m-0 d-contents">
                    <Link style={{paddingTop: "0px", marginTop: "18px"}} to="/our-team">Join Our Team</Link>
                  </h2>

                </div>
              </div>
            </Col>
            <Col md={6} lg={3} className="p-0">
              <div className="footer-form">
                <div className="footer_box">
                  <h2 className="text-white footerTitle">In the know</h2>
                  <h3 className="dec_inknow">
                    Sign up for our email list and be in the know for all
                    upcoming events, promotions, new styles + more! Don't worry,
                    you can opt out at anytime.
                  </h3>
                  <Form onSubmit={hndlnewsletter}>
                    <Form.Group className="mb-3" controlId="formBasicText">
                      <Form.Control
                        aria-label="YOUR NAME"
                        placeholder="YOUR NAME"
                        type="text"
                        value={newslettername}
                        onChange={(e) => setNewslettername(e.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Control
                        aria-label="EMAIL"
                        placeholder="EMAIL"
                        type="email"
                        value={newsletteremail}
                        onChange={(e) => setNewsletteremail(e.target.value)}
                        required
                      />
                    </Form.Group>
                    <ReCAPTCHA
                      aria-label="recaptcha"
                      sitekey="6Lc6LUscAAAAAKO2DYPGrIPSnwx3fzROCxJzNWQ0"
                      onChange={capthcaHandle}
                    />
                    <Button
                      title="SUBMIT"
                      aria-label="SUBMIT"
                      className="newsletter_btn"
                      type="submit"
                      disabled={captchaStatus ? true : false}
                    >
                      {loader ? "Sending..." : "SUBMIT"}
                    </Button>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
      <p className="copyright-text mobile_hide">
        © {new Date().getFullYear()} Wedding Day Diamonds <span>|</span>{" "}
        <Link to="/terms-and-conditions">Terms & Conditions</Link>{" "}
        <span>|</span> <Link to="/privacy-policy">Privacy Policy</Link>{" "}
        <span>|</span> <Link to="/">Accessibilty</Link> <span>|</span>{" "}
        <Link to="/">Site Map</Link>
      </p>

      <p className="copyright-text desktop_hide">
        © {new Date().getFullYear()} Wedding Day Diamonds <br /> <span>|</span>{" "}
        <Link to="/terms-and-conditions">Terms & Conditions</Link>{" "}
        <span>|</span> <Link to="/privacy-policy">Privacy Policy</Link>{" "}
        <span>|</span> <Link to="/">Accessibilty</Link> <span>|</span>{" "}
        <Link to="/">Site Map</Link>
      </p>

      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
        className="scroll-to-top-btn"
        onClick={scrollToTop}
        style={{ display: visible ? "inline" : "none" }}
      >
        <path d="M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"></path>
      </svg>

      {isLiveChatLoaded && (
        <Suspense fallback={<></>}>
          <LiveChatWidget
            license="4226431"
            visibility="minimized"
            onNewEvent={handleNewEvent}
          />
        </Suspense>
      )}

      {/* <Container>
            <div className='seo_urlsss'>
              <ul>
                    <li><a href="https://weddingdaydiamonds.com">https://weddingdaydiamonds.com</a></li>               
                    <li><a href="https://weddingdaydiamonds.com/special">https://weddingdaydiamonds.com/special</a></li>
                    <li><a href="https://weddingdaydiamonds.com/person-appointment">https://weddingdaydiamonds.com/person-appointment</a></li>
                    <li><a href="https://weddingdaydiamonds.com/terms-and-conditions">https://weddingdaydiamonds.com/terms-and-conditions</a></li>
                    <li><a href="https://weddingdaydiamonds.com/privacy-policy">https://weddingdaydiamonds.com/privacy-policy</a></li>
                    <li><a href="https://weddingdaydiamonds.com/contact-us">https://weddingdaydiamonds.com/contact-us</a></li>
                    <li><a href="https://weddingdaydiamonds.com/customer-service">https://weddingdaydiamonds.com/customer-service</a></li>
                    <li><a href="https://weddingdaydiamonds.com/stay-tuned">https://weddingdaydiamonds.com/stay-tuned</a></li>
                    <li><a href="https://weddingdaydiamonds.com/fall-band-event">https://weddingdaydiamonds.com/fall-band-event</a></li>
                    <li><a href="https://weddingdaydiamonds.com/wishlist">https://weddingdaydiamonds.com/wishlist</a></li>
                    <li><a href="https://weddingdaydiamonds.com/book-an-appointment">https://weddingdaydiamonds.com/book-an-appointment</a></li>
                    <li><a href="https://weddingdaydiamonds.com/showroom">https://weddingdaydiamonds.com/showroom</a></li>
                    <li><a href="https://weddingdaydiamonds.com/gallery">https://weddingdaydiamonds.com/gallery</a></li>
                    <li><a href="https://weddingdaydiamonds.com/education">https://weddingdaydiamonds.com/education</a></li>
                    <li><a href="https://weddingdaydiamonds.com/custom-design">https://weddingdaydiamonds.com/custom-design</a></li>
                    <li><a href="https://weddingdaydiamonds.com/person-appointment">https://weddingdaydiamonds.com/person-appointment</a></li>
                    <li><a href="https://weddingdaydiamonds.com/virtual-appointment">https://weddingdaydiamonds.com/virtual-appointment</a></li>
                    <li><a href="https://weddingdaydiamonds.com/free-custom-design">https://weddingdaydiamonds.com/free-custom-design</a></li>
                    <li><a href="https://weddingdaydiamonds.com/our-team">https://weddingdaydiamonds.com/our-team</a></li>
                    <li><a href="https://weddingdaydiamonds.com/our-difference">https://weddingdaydiamonds.com/our-difference</a></li>
                    <li><a href="https://weddingdaydiamonds.com/repairs">https://weddingdaydiamonds.com/repairs</a></li>
                    <li><a href="https://weddingdaydiamonds.com/sell-gold-silver-jewelry">https://weddingdaydiamonds.com/sell-gold-silver-jewelry</a></li>
                    <li><a href="https://weddingdaydiamonds.com/jewelry-guides">https://weddingdaydiamonds.com/jewelry-guides</a></li>
                    <li><a href="https://weddingdaydiamonds.com/engagement-rings-buying-guide">https://weddingdaydiamonds.com/engagement-rings-buying-guide</a></li>
                    <li><a href="https://weddingdaydiamonds.com/fashion-Jewelry-guide">https://weddingdaydiamonds.com/fashion-Jewelry-guide</a></li>
                    <li><a href="https://weddingdaydiamonds.com/lab-Grown-diamond-jewelry-guide">https://weddingdaydiamonds.com/lab-Grown-diamond-jewelry-guide</a></li>
                    <li><a href="https://weddingdaydiamonds.com/necklaces-and-pendants-guide">https://weddingdaydiamonds.com/necklaces-and-pendants-guide</a></li>
                    <li><a href="https://weddingdaydiamonds.com/ultimate-bracelet-guide">https://weddingdaydiamonds.com/ultimate-bracelet-guide</a></li>
                    <li><a href="https://weddingdaydiamonds.com/the-ultimate-guide-to-wedding-bands">https://weddingdaydiamonds.com/the-ultimate-guide-to-wedding-bands</a></li>
                    <li><a href="https://weddingdaydiamonds.com/earring-guide">https://weddingdaydiamonds.com/earring-guide</a></li>
                    <li><a href="https://weddingdaydiamonds.com/fashion-ring-guide">https://weddingdaydiamonds.com/fashion-ring-guide</a></li>
                    <li><a href="https://weddingdaydiamonds.com/gabriel-co">https://weddingdaydiamonds.com/gabriel-co</a></li>
                    <li><a href="https://weddingdaydiamonds.com/ring-promise">https://weddingdaydiamonds.com/ring-promise</a></li>
                    <li><a href="https://weddingdaydiamonds.com/fall-band-event">https://weddingdaydiamonds.com/fall-band-event</a></li>
                    <li><a href="https://weddingdaydiamonds.com/blog">https://weddingdaydiamonds.com/blog</a></li>
                    <li><a href="https://weddingdaydiamonds.com/spring-band-event">https://weddingdaydiamonds.com/spring-band-event</a></li>
                    <li><a href="https://weddingdaydiamonds.com/payment-declined">https://weddingdaydiamonds.com/payment-declined</a></li>
                    <li><a href="https://weddingdaydiamonds.com/financing">https://weddingdaydiamonds.com/financing</a></li>
                    <li><a href="https://weddingdaydiamonds.com/showroom">https://weddingdaydiamonds.com/showroom/</a></li>
                    <li><a href="https://weddingdaydiamonds.com/showroom/Burnsville">https://weddingdaydiamonds.com/showroom/Burnsville</a></li>
                    <li><a href="https://weddingdaydiamonds.com/showroom/Richfield">https://weddingdaydiamonds.com/showroom/Richfield</a></li>
                    <li><a href="https://weddingdaydiamonds.com/showroom/Minnetonka">https://weddingdaydiamonds.com/showroom/Minnetonka</a></li>
                    <li><a href="https://weddingdaydiamonds.com/showroom/Eden%20Prairie">https://weddingdaydiamonds.com/showroom/Eden%20Prairie</a></li>
                    <li><a href="https://weddingdaydiamonds.com/showroom/Maple%20Grove">https://weddingdaydiamonds.com/showroom/Maple%20Grove</a></li>
                    <li><a href="https://weddingdaydiamonds.com/showroom/St.%20Cloud">https://weddingdaydiamonds.com/showroom/St.%20Cloud</a></li>
                    <li><a href="https://weddingdaydiamonds.com/showroom/Woodbury">https://weddingdaydiamonds.com/showroom/Woodbury</a></li>
                    <li><a href="https://weddingdaydiamonds.com/showroom/Roseville">https://weddingdaydiamonds.com/showroom/Roseville</a></li>
                    <li><a href="https://weddingdaydiamonds.com/showroom/Rochester">https://weddingdaydiamonds.com/showroom/Rochester</a></li> 
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Solitaire">https://weddingdaydiamonds.com/productlist/engagement-rings/Solitaire</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Halo">https://weddingdaydiamonds.com/productlist/engagement-rings/Halo</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Hidden%20Accent">https://weddingdaydiamonds.com/productlist/engagement-rings/Hidden Accent</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Side%20stone">https://weddingdaydiamonds.com/productlist/engagement-rings/Side Stone</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Vintage">https://weddingdaydiamonds.com/productlist/engagement-rings/Vintage</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Nature">https://weddingdaydiamonds.com/productlist/engagement-rings/Nature</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Three%20stone">https://weddingdaydiamonds.com/productlist/engagement-rings/Three Stone</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Luxury">https://weddingdaydiamonds.com/productlist/engagement-rings/Luxury</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Modern">https://weddingdaydiamonds.com/productlist/engagement-rings/Modern</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings">https://weddingdaydiamonds.com/productlist/engagement-rings/Shop All</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Round">https://weddingdaydiamonds.com/productlist/engagement-rings/Round</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Oval">https://weddingdaydiamonds.com/productlist/engagement-rings/Oval</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Pear">https://weddingdaydiamonds.com/productlist/engagement-rings/Pear</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Princess">https://weddingdaydiamonds.com/productlist/engagement-rings/Princess</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Radiant">https://weddingdaydiamonds.com/productlist/engagement-rings/Radiant</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Emerald">https://weddingdaydiamonds.com/productlist/engagement-rings/Emerald</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Marquise">https://weddingdaydiamonds.com/productlist/engagement-rings/Marquise</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Cushion">https://weddingdaydiamonds.com/productlist/engagement-rings/Cushion</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/White">https://weddingdaydiamonds.com/productlist/engagement-rings/White Gold</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Yellow">https://weddingdaydiamonds.com/productlist/engagement-rings/Yellow Gold</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Rose">https://weddingdaydiamonds.com/productlist/engagement-rings/Rose Gold</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Platinum">https://weddingdaydiamonds.com/productlist/engagement-rings/Platinum</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/new-arrivals">https://weddingdaydiamonds.com/productlist/engagement-rings/New Style</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/best-sellers">https://weddingdaydiamonds.com/productlist/engagement-rings/best-sellers</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/best-sellers">https://weddingdaydiamonds.com/productlist/engagement-rings/Top Twenty</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Quick-Ship">https://weddingdaydiamonds.com/productlist/engagement-rings/Quick Ship</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Tierra%20Collection">https://weddingdaydiamonds.com/productlist/engagement-rings/Tierra</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Atia%20Couture">https://weddingdaydiamonds.com/productlist/engagement-rings/Atia%20Couture</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/The%20Grand%20Collection">https://weddingdaydiamonds.com/productlist/engagement-rings/The Grand</a></li>
                    <li><a href="https://weddingdaydiamonds.com/gabriel-co#/bridal">https://weddingdaydiamonds.com/productlist/engagement-rings/Gabriel & Co</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Diamond">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/diamond</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Curved">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/curved</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Mixed%20Shape">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/mixed-shape</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Eternity">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/eternity</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Stackables">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/stackables</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Plain">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/plain</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/new-arrivals">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/new-styles</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Round">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/round</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Marquise">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/marquise</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Princess">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/princess</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Pear">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/pear</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Emerald">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/emerald</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Oval">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/oval</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/shop-all</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Plain">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/plain</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Tantalum">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/tantalum</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Carved">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/carved</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Diamond">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/diamond</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Alternative">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Alternative</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/LUXE%20Band%20Collection">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/luxe-band-collection</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Nature">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/nature-inspired</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Mixed%20Shape">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Mixed%20Shape</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Curved">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/curved-bands</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/best-sellers">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/top-twenty</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/earrings">https://weddingdaydiamonds.com/productlist/earrings</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Stud">https://weddingdaydiamonds.com/productlist/earrings/Stud</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Gemstone">https://weddingdaydiamonds.com/productlist/earrings/Gemstone</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Silver">https://weddingdaydiamonds.com/productlist/earrings/Silver</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Plain%20Metal">https://weddingdaydiamonds.com/productlist/earrings/Plain%20Metal</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Hoops">https://weddingdaydiamonds.com/productlist/earrings/Hoops</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Fashion%20Earrings">https://weddingdaydiamonds.com/productlist/earrings/Fashion%20Earrings</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/">https://weddingdaydiamonds.com/productlist/necklaces/</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/Solitaire">https://weddingdaydiamonds.com/productlist/necklaces/Solitaire</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/Tennis">https://weddingdaydiamonds.com/productlist/necklaces/Tennis</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/Fashion">https://weddingdaydiamonds.com/productlist/necklaces/Fashion</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/Gemstone">https://weddingdaydiamonds.com/productlist/necklaces/Gemstone</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/Silver">https://weddingdaydiamonds.com/productlist/necklaces/Silver</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/">https://weddingdaydiamonds.com/productlist/bracelets/</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/Plain%20Metal">https://weddingdaydiamonds.com/productlist/bracelets/Plain%20Metal</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/Tennis">https://weddingdaydiamonds.com/productlist/bracelets/Tennis</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/Fashion">https://weddingdaydiamonds.com/productlist/bracelets/Fashion</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/Gemstone">https://weddingdaydiamonds.com/productlist/bracelets/Gemstone</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/Silver">https://weddingdaydiamonds.com/productlist/bracelets/Silver</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/">https://weddingdaydiamonds.com/productlist/fashion-rings/</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/Stackables">https://weddingdaydiamonds.com/productlist/fashion-rings/Stackables</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/Diamond">https://weddingdaydiamonds.com/productlist/fashion-rings/Diamond</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/Fashion">https://weddingdaydiamonds.com/productlist/fashion-rings/Fashion</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/Gemstone">https://weddingdaydiamonds.com/productlist/fashion-rings/Gemstone</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/Mixed%20shape">https://weddingdaydiamonds.com/productlist/fashion-rings/Mixed%20shape</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/">https://weddingdaydiamonds.com/productlist/fine-jewelry/</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/best-sellers">https://weddingdaydiamonds.com/productlist/fine-jewelry/best-sellers</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/Gemstone">https://weddingdaydiamonds.com/productlist/fine-jewelry/Gemstone</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/Silver">https://weddingdaydiamonds.com/productlist/fine-jewelry/Silver</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/Tennis">https://weddingdaydiamonds.com/productlist/fine-jewelry/Tennis</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/Mixed%20shape">https://weddingdaydiamonds.com/productlist/fine-jewelry/Mixed%20shape</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-500">https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-500</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-250">https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-250</a></li>
                    <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-over-2000">https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-over-2000</a></li>
                    <li><a href="https://weddingdaydiamonds.com/customer-service/">https://weddingdaydiamonds.com/customer-service/</a></li>
                    <li><a href="https://weddingdaydiamonds.com/customer-service/ring-cleaning">https://weddingdaydiamonds.com/customer-service/ring-cleaning</a></li>
                    <li><a href="https://weddingdaydiamonds.com/customer-service/engraving">https://weddingdaydiamonds.com/customer-service/engraving</a></li>
                    <li><a href="https://weddingdaydiamonds.com/customer-service/appraisals">https://weddingdaydiamonds.com/customer-service/appraisals</a></li>
                    <li><a href="https://weddingdaydiamonds.com/customer-service/engraving">https://weddingdaydiamonds.com/customer-service/engraving</a></li>
                </ul>
            </div>
            </Container> */}
    </>
  );
};

export default Footer;
